import React, { Component, Fragment } from 'react';
import { Alert, Card, Divider, Icon, Tag } from 'antd';

export class IndicatorDetails extends Component {
    render() {
        const position = this.props.position;
        if (!position) return null;

        return (
            <Card title={'Indicators'} bordered={false} style={{ marginTop: 15 }} size={'small'}>
                <b style={{ fontSize: 16 }}>Buy: {position.buy_indicators.group_name}</b>
                <br />
                {this.renderSignals(position.buy_indicators)}

                {position.sell_indicators ? (
                    <Fragment>
                        <b style={{ fontSize: 16 }}>
                            Sell on TA: {position.sell_indicators.group_name}
                        </b>
                        <br />
                        {this.renderSignals(position.sell_indicators)}
                    </Fragment>
                ) : null}
            </Card>
        );
    }

    renderSignals(group) {
        if (group.error) {
            return <div>{group.message}</div>;
        }

        if (group.hide_indicators)
            return (
                <Alert
                    message="The author has restricted the ability to view indicator output"
                    type="warning"
                    icon={<Icon type="lock" />}
                    showIcon
                />
            );

        if (!group.signal) return;
        return group.signal.signals.map((signal, i) => {
            if (!signal) {
                return null;
            }

            return (
                <div key={i} style={{ marginBottom: 8, position: 'relative' }}>
                    <div style={{ textAlign: 'left', fontSize: '0.9em' }}>
                        {' '}
                        {signal.a_label}: <Tag>{signal.a}</Tag>
                    </div>
                    <div
                        style={{
                            textAlign: 'right',
                            fontWeight: 'bold',
                            fontSize: '0.9em',
                            position: 'absolute',
                            right: 0,
                            top: 13
                        }}
                    >
                        {signal.fired ? (
                            <Icon
                                type="check-circle"
                                theme="filled"
                                style={{ color: '#436b45', marginRight: 5 }}
                            />
                        ) : (
                            <Icon
                                type="close-circle"
                                theme="filled"
                                style={{ color: '#ba7272', marginRight: 5 }}
                            />
                        )}{' '}
                        {this.getClause(signal.clause)}
                    </div>
                    <div style={{ textAlign: 'left', fontSize: '0.9em', marginTop: 4 }}>
                        {signal.b_label}: <Tag>{signal.b}</Tag>
                    </div>
                    <Divider style={{ margin: '10px 0' }} />
                </div>
            );
        });
    }

    getClause(clause) {
        switch (clause) {
            case 'eq':
                return 'Equals';
            case 'lt':
                return 'Less than';
            case 'lte':
                return 'Less than or equals';
            case 'gt':
                return 'Greater than';
            case 'gte':
                return 'Greater than or equals';
            case 'cross_above':
                return 'Cross above';
            case 'cross_below':
                return 'Cross below';
            default:
                return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionView/IndicatorDetails.js